import { YoutubePlatform } from '@app/modules/social-export/domain/platforms';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Alert, Box } from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';
import { DefaultPlatformConnect } from '../../../screens/manage/DefaultPlatformConnect';
type Props = {
  stationId: string;
};

export function YoutubeConnect({ stationId }: Props) {
  const { $t } = useIntl();

  return (
    <div>
      <Alert icon={<InfoOutlinedIcon />} severity="warning" sx={{ mb: 2 }}>
        <FormattedMessage
          id="socialExport.youtube.advancedModeNote"
          defaultMessage="NOTA: el modo avanzado permite funcionalidades adicionales, como por ejemplo el borrado de vídeos en la plataforma."
        />
      </Alert>
      <Box sx={{ display: 'flex', gap: 2 }}>
        <DefaultPlatformConnect platform={YoutubePlatform} stationId={stationId}>
          {$t({
            id: 'socialExport.connect',
            defaultMessage: 'Conectar',
          })}
        </DefaultPlatformConnect>
        <DefaultPlatformConnect
          platform={YoutubePlatform}
          stationId={stationId}
          loginSuffix="advanced"
        >
          {$t({
            id: 'socialExport.youtube.connectAdvanced',
            defaultMessage: 'Conectar (modo avanzado)',
          })}
        </DefaultPlatformConnect>
        <DefaultPlatformConnect
          platform={YoutubePlatform}
          stationId={stationId}
          loginSuffix="partner"
        >
          {$t({
            id: 'socialExport.youtube.connectPartner',
            defaultMessage: 'Conectar (modo partner)',
          })}
        </DefaultPlatformConnect>
      </Box>
    </div>
  );
}
